document.addEventListener('touchstart', function (event) {});

$(function () {
    var settings = {
        easing: 'easeInOutCirc',
    };
    // utils
    // utils
    // utils

    // allow touch swipe to click
    $.extend($.fn.swipe.defaults, {
        tap: function (ev) {
            // pass through taps as clicks
            $(ev.target).click();
        },
    });

    function updateHeights() {
        var $elements = $('[data-equal-height]');

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

        $elements.css('height', '');
        $elements.each(function () {
            $el = $(this);
            topPostion = $el.position().top;

            if (currentRowStart != topPostion) {
                // we just came to a new row.  Set all the heights on the completed row
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }

                // set the variables for the new row
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                // another div on the current row.  Add it to the list and check if it's taller
                rowDivs.push($el);
                currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
            }

            // do the last row
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    }
    $(window).on('resize', updateHeights);
    updateHeights();

    scrollTo = function (offset, speed, easing) {
        var attemptsLeft, scrollTo;
        offset = parseInt(offset);
        attemptsLeft = 2;
        scrollTo = (function (_this) {
            return function () {
                var scrolling, targetScrollTop;
                scrolling = true;
                targetScrollTop = $(_this).offset().top - (offset || 50);
                return $('body, html')
                    .stop(true, true)
                    .animate(
                        {
                            scrollTop: targetScrollTop,
                        },
                        speed || 650,
                        easing || 'easeInOutExpo',
                        function () {
                            if ($(window).scrollTop() !== targetScrollTop && attemptsLeft > 0) {
                                scrollTo();
                                return attemptsLeft--;
                            }
                        },
                    );
            };
        })(this);
        return scrollTo();
    };

    $.fn.extend({
        scrollTo: function () {
            return scrollTo.apply(this, arguments);
        },
    });

    $('[data-scroll-to]').each(function (index, el) {
        var $scrollToEl, scrollToSelector;
        scrollToSelector = $(this).data('scroll-to');
        $scrollToEl = $(scrollToSelector);
        if ($scrollToEl.length > 0) {
            return $(this).click(function () {
                return $scrollToEl.scrollTo($(this).data('scroll-to-offset') || 0);
            });
        }
    });
    readCookie = function (name) {
        var c, ca, i, nameEQ;
        nameEQ = name + '=';
        ca = document.cookie.split(';');
        i = 0;
        while (i < ca.length) {
            c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length).replace(/"/g, '');
            }
            i++;
        }
    };

    setCookie = function (cookieName, cookieValue) {
        var expire, today;
        today = new Date();
        expire = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        return (document.cookie =
            cookieName + '=' + escape(cookieValue) + ';expires=' + expire.toGMTString());
    };
    /*
	Stick element to top

	Version 0.01

	Usage:

	$("#product_preview_container").stickyElement({ // apply to element to stick.
		stopPoint: $("#products_see_more"), // integer or jquery element to stop fading at
		stopPointOffset: 100, // offset the stop point
		stickThreshold: 89, // when to start sticking
		topOffset: 0
	})

	By Yuji Tomita
	February 26, 2012.
	*/
    stickAt = function (offset, fixed) {
        var stickyClass;
        if (window.is_mobile) {
            // disabled stickAt due to mobile
            return;
        }
        offset = parseInt(offset);
        stickyClass = $(this).data('stick-at-class') || 'is-sticky';
        return $(window).on(
            'scroll.sticky',
            (function (_this) {
                return function () {
                    var scrollTop, sticky;
                    scrollTop = $(window).scrollTop();
                    if (fixed) {
                        sticky = function () {
                            return scrollTop >= $(_this).offset().top - offset;
                        };
                    } else {
                        sticky = function () {
                            return scrollTop >= offset;
                        };
                    }
                    if (sticky()) {
                        return $(_this).addClass(stickyClass);
                    } else {
                        return $(_this).removeClass(stickyClass);
                    }
                };
            })(this),
        );
    };

    $('[data-stick-at]').each(function (index, el) {
        return stickAt.apply(el, [$(el).data('stick-at'), $(el).data('stick-at-fixed')]);
    });

    if (window.location.hash.length > 1) {
        var hash = window.location.hash;
        if (hash == '#fragrances') {
            _.delay(function () {
                $('.product-list-wrapper').scrollTo();
            }, 100);
        }
    }

    // product
    // product
    // product

    $('.product-detail-quantity-down, .product-detail-quantity-up').click(function () {
        var $input = $(this).parent().find('input[name=quantity]');
        var currentVal = Number($input.val());
        var nextVal = currentVal;
        var $count = $(this).parent().find('.product-detail-quantity-count');
        // up
        if ($(this).hasClass('product-detail-quantity-up')) {
            nextVal = currentVal + 1;
        } else {
            if (nextVal > 1) {
                nextVal = currentVal - 1;
            }
            $count.addClass('down');
        }
        if (nextVal == 1 && currentVal == 1) {
            // don't animate if value not changing
            return;
        }
        $input.val(nextVal);
        $count.html(nextVal);
        $count.addClass('is-animated');
        _.delay(function () {
            $count.removeClass('is-animated down');
        }, 300);
        // $count.animate({})
    });

    $('.product-add-to-cart').click(function () {
        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            data: $(this).closest('.product-detail-content').find(':input').serialize(),
            dataType: 'json',
        }).success(function (response) {
            window.cartHandler.refreshCartStateAndRender();
            window.cartHandler.show();
        });
    });

    $('.product-sample-selector select')
        .change(function () {
            var val = $(this).val();
            $('[name=id]').val(val);
        })
        .trigger('change');

    $('.product-list-item-image').on('load', function () {
        updateHeights();
    });

    // mobile nav
    // mobile nav
    // mobile nav
    $mobileNavbar = $('.mobile-navbar-wrapper');
    function closeMobileNav() {
        // if we can pull slide-right off with CSS> good. Otherwise, remove.
        $mobileNavbar.removeClass('is-open');
        // $mobileNavbar.slideUp('slow', settings.easing);
        $('.hamburger').removeClass('is-open');
    }
    function openMobileNav() {
        // if we can pull slide-right off with CSS> good. Otherwise, remove.
        // $mobileNavbar.slideDown('slow', settings.easing);
        $('html, body').animate({ scrollTop: 0 }, 500, settings.easing);
        $mobileNavbar.addClass('is-open');

        $('.hamburger').addClass('is-open');
        $(window).trigger('scroll');
    }
    $('.reveal-mobile-navbar').click(function () {
        if ($mobileNavbar.hasClass('is-open')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });
    $('.mobile-navbar-fragrances, .mobile-navbar-about').click(function () {
        closeMobileNav();
    });
    // cart
    // cart
    // cart

    $('.navbar-cart').click(function () {
        window.cartHandler.show();
    });

    window.cartHandler = {
        debug: true,
        showContainerSpeed: 500,
        easing: 'easeInOutExpo',
        $container: $('.cart-container'),
        $cartItemsContainer: $('.cart-items-container'),
        $cartItemTemplate: $('.cart-item-template'),
        $cartItemCount: $('.quantity-in-cart'),
        init: function () {
            // get cart state.
            this.refreshCartStateAndRender();
            this.bindCloseHandlers();
        },
        bindCloseHandlers: function () {
            var self = this;
            $(document).on('click', function (ev) {
                var $target = $(ev.target);

                if (
                    $target.closest('.cart-container').length == 0 && // there is no parent with the cart class
                    !$target.hasClass('navbar-cart') && // this element is not directly the cart init button
                    !$target.closest('.navbar-cart').length > 0
                ) {
                    // this element is not a child of the cart init button
                    // clicked outside of cart.
                    self.hide();
                }
            });
        },
        refreshCartStateAndRender: function () {
            var self = this;

            $.ajax({
                url: '/cart.js',
                data: {},
                dataType: 'json',
            })
                .done(function (response) {
                    self.$cartItemsContainer.html('');

                    // succeeded getting state from shopify

                    var items = response.items;
                    // update counts
                    var count = response.item_count;
                    self.$cartItemCount.html(count);
                    // update totals
                    var baseSelector = '.cart-summary-value-';

                    $(baseSelector + 'total').html('$' + response.total_price / 100);

                    for (var i = items.length - 1; i >= 0; i--) {
                        self._renderItem(items[i]);
                    }
                })
                .fail(function (xhr, responseText) {
                    self.log('failed getting state from shopify');
                    self.log(xhr);
                });
        },
        log: function (msg) {
            if (this.debug) {
                console.log(msg);
            }
        },
        addToCart: function (variant_id, qty) {
            var self = this;
            $.ajax({
                url: '/cart/add/',
                data: {
                    variant_id: variant_id,
                    quantity: qty,
                },
                dataType: 'json',
            })
                .success(function (response) {
                    self.refreshCartStateAndRender();
                })
                .fail(function () {
                    self.log('failed adding');
                });
        },
        _renderItem: function (item) {
            var self = this;

            var rendered = _.template(self.$cartItemTemplate.html(), {
                item: item,
            });

            self.$cartItemsContainer.append(rendered);
        },
        removeFromCart: function (variant_id) {
            var self = this;
            var updates = {};
            updates[variant_id] = 0;
            $.post('/cart/update.js', { updates: updates });

            // remove call.
            self.refreshCartStateAndRender();
        },
        updateQuantity: function () {
            var self = this;
            // update qty call
            self.refreshCartStateAndRender();
        },
        show: function () {
            var self = this;

            self.$container.addClass('is-open');

            // allow closing of the cart on click.
            // re-binding is easier than detecting all scenarios that are valid cart-open triggers.
        },
        hide: function () {
            var self = this;

            self.$container.removeClass('is-open');
        },
    };
    cartHandler.init();

    // animations
    $('.animate-on-hover').bind('webkitAnimationEnd mozAnimationEnd animationEnd', function () {
        $(this).removeClass('animated');
    });

    $('.animate-on-hover').on('mouseenter', function () {
        $(this).addClass('animated');
    });

    // home
    // home
    // home

    function onWindowChange() {
        // cache window height
        window.windowHeight = $(window).height();
    }
    onWindowChange();
    $(window).on('resize', onWindowChange);

    // newsletter
    // newsletter
    // newsletter

    if (!readCookie('newsletter-closed')) {
        if ($('html').hasClass('is-not-mobile')) {
            setTimeout(function () {
                $('.newsletter-overlay').fadeIn();
            }, 7000);
        }
    }

    $('.newsletter-signup-trigger').on('click', function (ev) {
        ev.preventDefault();
        $('.newsletter-overlay').fadeIn(function () {
            $(this).css('display', 'block');
        });
    });

    function closeNewsletter() {
        $('.newsletter-overlay').fadeOut();
        setCookie('newsletter-closed', true);
    }

    $('.newsletter-close-icon').click(closeNewsletter);

    $('.newsletter-email').click(function () {
        $('.newsletter-email').removeClass('is-invalid');
    });

    //submit newsletter//
    $('.newsletter-overlay-signup-form form').on('submit', function (ev) {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var potentialEmail = document.getElementById('MERGE0').value;
        if (testEmail.test(potentialEmail)) {
            $('.newsletter-submit').val('THANKS');
            $('.newsletter-overlay').fadeOut();
            setCookie('newsletter-closed', true);
        } else {
            ev.preventDefault();
            $('.newsletter-email').addClass('is-invalid');
        }
    });

    // $(".newsletter-signup-trigger").click(function() {
    // 	var $popup = $(".newsletter-popup-wrapper").addClass('is-open');
    // 	$("body").scrollTo();
    // })

    // show loading overlay
    if ($('body').hasClass('index')) {
        if (!readCookie('loading-animation-shown')) {
            $('.loading-overlay-wrapper').addClass('is-animated');
            _.delay(function () {
                $('.loading-overlay-wrapper').remove();
            }, 4000);
            setCookie('loading-animation-shown', true);
        } else {
            $('.loading-overlay-wrapper').remove();
        }

        if (!window.is_mobile) {
            // scroll fade to 0
            var $window = $(window);
            var $homeGallery = $('.gallery-container');
            var $homeGalleryText = $('.gallery-text-wrapper');
            function handleScroll() {
                var scrollTop = $window.scrollTop();
                if (scrollTop < window.windowHeight) {
                    /// reasonable threshold.. ignore if user has scrolled quite a ways.
                    var scrolledRatio = scrollTop / (window.windowHeight * 0.8);
                    var opacity = 1 - scrolledRatio;

                    $homeGallery.css('opacity', opacity);

                    if (scrolledRatio > 0.15) {
                        $homeGalleryText.addClass('is-hidden');
                    } else {
                        $homeGalleryText.removeClass('is-hidden');
                    }
                }
            }
            $(window).on('scroll', handleScroll);
        }

        function Carousel() {
            // image carousel on homepage
            var self = this;

            var $container = $('.gallery-container');
            var $carouselElement = $('.gallery-container .gallery-items');
            var $items = $('.gallery-container .gallery-item');
            var $navs = $('.gallery-nav');
            var currentIndex = 0;
            var maxIndex = $items.length;

            self.init = function () {
                self.bindHandlers();
                self.cacheDims();

                $(window).on('resize', self.onResize);
                self.onResize();

                if (window.is_mobile) {
                    self.initializeMobile();
                }

                self.autoplay();
            };
            self.autoplay = function () {
                var id = setInterval(function () {
                    self.next();
                }, 4000);
            };
            self.initializeMobile = function () {
                $container.swipe({
                    swipe: function (event, direction, distance, duration, fingerCount) {
                        if (direction == 'left') {
                            $navs.filter('.gallery-nav-left').click();
                        } else if (direction == 'right') {
                            $navs.filter('.gallery-nav-right').click();
                        }
                    },
                    allowPageScroll: 'vertical',
                });
            };

            self.onResize = _.throttle(
                function () {
                    self.cacheDims();
                    self.goTo(currentIndex);
                },
                100,
                { leading: false },
            );

            self.cacheDims = function () {
                // self.windowHeight = $(window).height();
                self.windowWidth = $(window).width();
            };

            self.bindHandlers = function () {
                // navhandlers to be enabled if there is more than one unit.
                if ($items.length > 1) {
                    self.bindNavHandlers();
                } else {
                    $navs.remove();
                }
            };
            self.bindNavHandlers = function () {
                $items.on('mousemove', function (ev) {
                    // mouse position; slides are full width so abs position works.
                    var x = ev.pageX;
                    // left side = < ww/2
                    // right side = > ww/2

                    $container.removeClass('is-left-hover is-right-hover');
                    if (x < (self.windowWidth * 1) / 4) {
                        $container.addClass('is-left-hover');
                    } else if (x > (self.windowWidth * 3) / 4) {
                        $container.addClass('is-right-hover');
                    }
                });
                $navs.on('click', function () {
                    if ($(this).hasClass('gallery-nav-right')) {
                        // right
                        self.next();
                    } else {
                        // left
                        self.previous();
                    }
                });
            };

            self.next = function () {
                var next = currentIndex + 1;
                if (next >= maxIndex) {
                    next = 0;
                }
                var $next = $items.eq(next);
                self.goTo(next);
            };

            self.previous = function () {
                var next = currentIndex - 1;
                if (next < 0) {
                    next = maxIndex - 1;
                }
                self.goTo(next);
            };

            self.goTo = function (next) {
                var $next = $items.eq(next);
                var left = next * self.windowWidth;

                $carouselElement.css({
                    transform: 'translateX(' + -1 * left + 'px)',
                });
                currentIndex = next;

                var $current = $items.filter('.is-active');
                $items.removeClass('is-active is-active-out');
                $current.addClass('is-active-out').removeClass('is-active');

                $next.addClass('is-active');
            };

            self.init();
        }
        carousel = new Carousel();
    }

    // handle element scroll in viewport
    timedFunctions = [];
    var timedFunctionStack = function (func, interval) {
        timedFunctions.push(func);
    };

    function handleShowOnScroll() {
        $elements = $('.show-on-scroll:visible');
        $elements.each(function (index, el) {
            var $el = $(el);
            var bottom = $(window).scrollTop() + $(window).height();
            var elTop = $el.offset().top;
            var threshold = -100;
            if (bottom > elTop - threshold) {
                if (!$(el).data('queued')) {
                    $(el).data('queued', true);
                    $(document).queue(function (next) {
                        $el.addClass('is-in-viewport');
                        _.delay(function () {
                            next();
                        }, 100);
                    });
                }
            }
        });
    }
    $(window).on('scroll', handleShowOnScroll);
    handleShowOnScroll();

    $('.gallery-item').click(function () {
        $('html, body').animate(
            {
                scrollTop: $('.product-list-wrapper').offset().top,
            },
            1500,
            'easeInOutExpo',
        );
    });
});
